module.exports = __webpack_public_path__ + "static/media/our-last-catalog-img.60923802.png";